import React, { useEffect, useState } from 'react';
import { TabView, TabPanel } from 'primereact/tabview';
import "./DashBoard.css"
import 'primeflex/primeflex.css';
import Setup from './dashboard/Setup';
import Settings from './dashboard/Settings';
import Census from './dashboard/Census';
import { useAuthServices } from '../hooks/useAuthServices';
import Attendance from './dashboard/Attendance';

export const Dashboard = () => {
    const [activeIndex, setActiveIndex] = useState(0);
    const {actions :{GetToken}} = useAuthServices();      
    
    useEffect(()=>{       
        GetToken && GetToken();
    }, [GetToken])
   
    const tabChange = (e) => {
        setActiveIndex(e.index);
    };

    return (
        <div className="p-grid">
            <div className="p-col-12" style={{ display: 'none' }}>
                <h4>Bed Management</h4>
            </div>

            <div className="p-col-12">
                <TabView activeIndex={activeIndex} onTabChange={(e) => tabChange(e)}>
                    <TabPanel header="Census">
                        <Census/>
                    </TabPanel>
                    <TabPanel header="Attendance">
                       <Attendance/>
                    </TabPanel>
                    <TabPanel header="Waitlist">
                        Waitlist
                    </TabPanel>
                    <TabPanel header="Setup" style={{backgroundColor:"#fff"}}>
                        <Setup/>                       
                    </TabPanel>
                    <TabPanel header="Settings" style={{backgroundColor:"#fff"}}>
                        <Settings/>                       
                    </TabPanel>
                </TabView>
            </div>
        </div>
    )
}
